import styles from '@styles/scss/performer/_mainContentHeader.module.scss';
import { Performer } from 'lib/types/item/performer';
import { PerformerPage } from 'lib/types/item/performerPage';

export default function MainContentHeader({
    performerPage,
    performer
}: {
    performer: Performer;
    performerPage: PerformerPage;
}): JSX.Element {
    return (
        <div className={styles.chatRoomTitle}>
            <div>
                <h1>{performerPage.performer_h1}</h1>
            </div>
            <div>
                <p>
                    {performer.is_online === 1
                        ? performerPage.online_text
                        : performerPage.offline_text}
                </p>
            </div>
        </div>
    );
}
